import {inject, injectable} from 'inversify';

import type {QuestionModel} from './Question.model';

import {AppError} from '../../../utils/errors/app';
import {ChoiceQuestionFactory} from './ChoiceQuestion/ChoiceQuestion.factory';
import {ChoiceQuestionModel} from './ChoiceQuestion/ChoiceQuestion.model';
import {TextQuestionFactory} from './TextQuestion/TextQuestion.factory';
import {TextQuestionModel} from './TextQuestion/TextQuestion.model';

@injectable()
export class QuestionFactory {
  constructor(
    @inject(ChoiceQuestionFactory)
    private readonly choiceQuestionFactory: ChoiceQuestionFactory,
    @inject(TextQuestionFactory)
    private readonly textQuestionFactory: TextQuestionFactory,
  ) {}

  create(props: QuestionModel.Props): QuestionModel {
    switch (true) {
      case ChoiceQuestionModel.isChoiceQuestionProps(props):
        return this.choiceQuestionFactory.create(props);
      case TextQuestionModel.isTextQuestionProps(props):
        return this.textQuestionFactory.create(props);
      default:
        throw new AppError(
          `QuestionFactory for type ${(props as QuestionModel.Props).type} has not found.`,
        );
    }
  }
}
